import { PaymentChannelEnum } from './payment-model';

export class PaymentListItemModel {
  fromObject(object: any): PaymentListItemModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public paymentId: number;
  public paymentCode: string;
  public paymentDate: Date;
  public paymentChannel: PaymentChannelEnum;

  public customerId: number;
  public payerName: string;
  public payerTaxId: string;

  public amount: number;
  public amountLeft: number;

  public createUserName: string;

  public invoiceCodes: string[];
  public comment: string;
}
